import React from 'react'
import { cn } from '@/utils/style.ts'
import { ClassValue } from 'clsx'

type SpinnerProps = {
  show?: boolean
  className?: ClassValue
}

export const Spinner: React.FC<SpinnerProps> = ({ show = true, className }) => {
  return (
    <div
      className={cn(
        'h-16 w-16 flex items-center justify-center',
        'rounded-full border-input border-8 border-t-primary animate-spin collapse',
        {
          visible: show
        },
        className,
      )}
    />
  )
}